module.exports = __webpack_public_path__ + "static/img/pk-img2.05bb0a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pk-img2.png
// module id = Xts5
// module chunks = 1